import { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { Brush } from "lucide-react";
import api, { API } from "@/lib/api";
import CategorizedGallery from "@/components/CategorizedGallery";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const abs = (u) => (u && u.startsWith("http") ? u : `${BACKEND}${u}`);

export default function GalleryPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data))
      .catch((error) => console.error("Failed to load gallery:", error))
      .finally(() => setLoading(false));
  }, []);

  const images = useMemo(() => items.map((g) => ({
    id: g.id,
    src: g.url && g.url.startsWith("http") ? g.url : `${API}/files/${g.file_id}`,
    category: ["solo", "couple", "family", "pet", "wedding", "friends", "gifts", "anniversary", "special_occasion", "party"].includes(g.category) ? g.category : "solo",
    caption: g.title || "",
  })), [items]);

  return (
    <div className="max-w-7xl mx-auto px-5 py-12" data-testid="gallery-page">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div>
          <span className="font-accent text-3xl text-bubble">the good stuff</span>
          <h1 className="font-display font-bold text-4xl sm:text-5xl">Example gallery</h1>
          <p className="text-ink/60 text-lg mt-1">Browse by category — solo, couples, family, pets &amp; weddings.</p>
        </div>
        <Link to="/order" className="brut-btn bg-bubble text-white">Order yours <Brush className="w-5 h-5" /></Link>
      </div>

      {loading ? (
        <div className="font-display text-xl">Loading gallery…</div>
      ) : (
        <CategorizedGallery images={images} />
      )}
    </div>
  );
}
